import { Dispensary } from "custom-types/Dispensary";

const isDispensaryUnclaimed = (dispensary: Dispensary) =>
  dispensary.featureTier === "info" &&
  dispensary.retailType === "clinic" &&
  dispensary.country === "US";

export default isDispensaryUnclaimed;
